import { Route } from 'react-router-dom';
import { ScenarioDetailPage } from './pages/ScenarioDetailPage.js';
import { ScenarioListPage } from './pages/ScenarioListPage.js';

/**
 * Scenario — largest slice. Three role-aware variants share the
 * same engine-list response today; Phase B forks them on column
 * sets and per-role permissions. Detail page renders the engine
 * scenario snapshot. Blueprint compare lives in the per-row
 * actions menu (`ScenarioCompareCodeDialog`) — opened in-place
 * rather than via its own route since the modal owns its state.
 */
export function scenarioRoutes(): JSX.Element {
  return (
    <>
      <Route path="/scenarios" element={<ScenarioListPage role="business" />} />
      <Route path="/scenarios/administrator" element={<ScenarioListPage role="administrator" />} />
      <Route path="/scenarios/developer" element={<ScenarioListPage role="developer" />} />
      <Route path="/scenarios/:scenarioId" element={<ScenarioDetailPage />} />
    </>
  );
}
